// extracted by mini-css-extract-plugin
export default {"topSection":"_8f22155d","middleSection":"_3e798adb","wrapper":"_9bd646c","appliedFiltersWrapper":"_27840d9a","sortAndPriceContainer":"_82a72624","label":"_8b66a879"};